import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const COMMISSION_FIELDS = `
  id,
  name
  type
  salesLimit
  hasSalesLimit
  amount
`

const COMMISSION_VARIABLES = `
  $name: String!
  $type: String!
  $salesLimit: Int
  $hasSalesLimit: Boolean
  $amount: Decimal
`;

const COMMISSION_ARGUMENTS = `
  name: $name
  type: $type
  salesLimit: $salesLimit
  hasSalesLimit: $hasSalesLimit
  amount: $amount
`;

const COMMISSION_FIELDS_AND_ERRORS = `
  commission {
    ${COMMISSION_FIELDS}
  }
  ${ERRORS}
`;

export const COMMISSIONS_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    commissionsWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ${COMMISSION_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_COMMISSION = gql`
  mutation CreateCommission(
    ${COMMISSION_VARIABLES}
  ) {
    createCommission(
      ${COMMISSION_ARGUMENTS}
    ) {
      ${COMMISSION_FIELDS_AND_ERRORS}
    }
  }
`;

export const UPDATE_COMMISSION = gql`
  mutation UpdateCommission(
    $id: ID!
    ${COMMISSION_VARIABLES}
  ) {
    updateCommission(
      id: $id
      ${COMMISSION_ARGUMENTS}
    ) {
      ${COMMISSION_FIELDS_AND_ERRORS}
    }
  }
`;

export const COMMISSION = gql`
  query Commission($id: ID!) {
    commission(id: $id) {
      ${COMMISSION_FIELDS}
    }
  }
`;

export const HIDE_COMMISSION = gql`
  mutation HideCommission($id: ID!) {
    hideCommission(id: $id) {
      commission {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;
